// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 3524) return "static/chunks/2170a4aa-f85825828d2c3000.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"501":"bc98253f","3930":"164f4fb6","4316":"ad2866b8"}[chunkId] || chunkId) + "." + {"501":"d13bf505216111a2","3756":"e3dcfa47bb7b359c","3930":"fdd00314926e72cf","4316":"da7517a88118b074","5007":"c5b1d78c69cf8bef","6735":"a3eb23c166e5ee5a","8436":"39669319b9f31b0a","9839":"6c8deffd9803ea0e"}[chunkId] + ".js";
};